import currencyList from '../currencyList';
import { calculateRate } from '../utils/conversionUtils';
import { cacheTargetCurrency } from './targetCurrency';

const CONFIG = {
  get baseCurrency() {
    return this.storeProfile.formatsAndUnits.currency;
  },
};

const getConfig = () => {
  return CONFIG;
};

const setConfig = ({ appConfig, storeProfile }) => {
  CONFIG.appConfig = appConfig;
  CONFIG.storeProfile = storeProfile;
};

const setTargetCurrency = (targetCurrency) => {
  cacheTargetCurrency(targetCurrency);
  CONFIG.targetCurrency = targetCurrency;
  CONFIG.targetCurrencyInfo = currencyList.find(
    ({ code }) => code === targetCurrency
  );
  const { baseCurrency } = CONFIG;
  if (baseCurrency === targetCurrency) {
    CONFIG.rate = 1;
    return;
  }
  const autoCurrencyRates = CONFIG.appConfig.autoCurrencyRates;
  const customRate =
    CONFIG.appConfig.customCurrencyRates[`${baseCurrency}${targetCurrency}`];
  CONFIG.rate =
    customRate ||
    calculateRate(baseCurrency, targetCurrency, autoCurrencyRates);
};

export default { getConfig, setConfig, setTargetCurrency };
